var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edittext" }, [
    _vm.text !== null
      ? _c("textarea", {
          ref: "textArea",
          staticClass: "privateData",
          attrs: {
            placeholder: _vm.$t("views.editText.textPlaceHolder"),
            autocomplete: "off",
            autofocus: "",
            "data-private": "lipsum",
          },
          domProps: { innerHTML: _vm._s(_vm.text) },
          on: {
            keyup: function ($event) {
              return _vm.editText($event.target.value)
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.closeIcon
      ? _c("div", { staticClass: "hideIcon", on: { click: _vm.close } }, [
          _c("i", { staticClass: "far fa-2x fa-angle-double-left" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }